import { Balance, Token } from "./types";

export const WRAPPED_TOKENS = [
	'resource_rdx1thxj9m87sn5cc9ehgp9qxp6vzeqxtce90xm5cp33373tclyp4et4gv', // hUSDC
	'resource_rdx1th4v03gezwgzkuma6p38lnum8ww8t4ds9nvcrkr2p9ft6kxx3kxvhe', // hUSDT
	'resource_rdx1th09yvv7tgsrv708ffsgqjjf2mhy84mscmj5jwu4g670fh3e5zgef0', // hETH
	'resource_rdx1t58kkcqdz0mavfz98m98qh9m4jexyl9tacsvlhns6yxs4r6hrm5re5', // hwBTC
	'resource_rdx1t5ljlq97xfcewcdjxsqld89443fchqg96xv8a8k8gdftdycy9haxpx', // hSOL

	"resource_rdx1t4upr78guuapv5ept7d7ptekk9mqhy605zgms33mcszen8l9fac8vf", // xUSDC
	"resource_rdx1thrvr3xfs2tarm2dl9emvs26vjqxu6mqvfgvqjne940jv0lnrrg7rw", // xUSDT
	"resource_rdx1t580qxc7upat7lww4l2c4jckacafjeudxj5wpjrrct0p3e82sq4y75", // xwBTC
	"resource_rdx1th88qcj5syl9ghka2g9l7tw497vy5x6zaatyvgfkwcfe8n9jt2npww", // xETH

	// "resource_rdx1tk35r6nlyjnt0aqjv7re27gu72ly7d3dwehe9e5k2nwjaue8fxtpkv", // XRP
	// "resource_rdx1t49ukgsdsfv0232vez5nr2z9a0cwd6vjrzsssgxt9zlqglr5kxwpr9", // xADA
	// "resource_rdx1t5jlk3wlxrvml2a0aa59h8cjt59utuku8qt5mlt8s8590qt024km3y", // WLD
	// "resource_rdx1tk0ma9ngnle2jka3j33d5d7072ywy033x0d6fkvc3x9sz6ts3nvxmz", // POL
	// "resource_rdx1thkhj9gzgkd97m0fk79x0pd4y6qqhw60v6frh3nrhllxp83ma666jn", // TRX
	// "resource_rdx1thc7rlr7hc9xh57q4slysppznam3py9h5spjm0jfu7x7t578gd6duk", // XLM
	// "resource_rdx1t56xvxq96c02vxsmp0uzq7r4zk2wqam5mjjg98ytv7aadgwagj60p7", // GRT
	// "resource_rdx1tk3rs0wmsja4sldml4tkj993s7669heulw57jva777h5eqmg6xf8mx", // IMX
	// "resource_rdx1tkc8uhc3frpveynthwzh0675zlv9cxzd68dvs6lcu6x5hc0wxkdw34", // MKR
	// "resource_rdx1tkyw4z4dxx8zwzg9qyu2fxjj9my5pdmzhs75unt03yxrrufvs3d786", // AAVE
	// "resource_rdx1t5qhyvgr5mh2nrwwntkk9q3nuy9e9rddgps68shalucr0cyx9fwrwv", // ETC
	// "resource_rdx1t5lwaxl3f6f88mtxvhhq6jd6dmv6u0hr9ssrqhvg3a8vw92yau4w8a", // CRO
	// "resource_rdx1t55ja5ser4g8rkh2qm6jhr44zej9h6yd2z9n34e3wffrhnth6e5awe", // SHIB
	// "resource_rdx1t5ytfqwtqjfyq2ku0n5r4d275h2uc9cx0s4l6fghaffgnvsatjw6hk", // UNI
	// "resource_rdx1t5d2qch32njedqpa204yswpxmxea5wazqf7tavptcxgq5j77suuxlr", // ENA
	// "resource_rdx1thc7mxrzd3u2v9nfd8zm52juswrsk9f74gqmzk5z46ap2vqk6cut3e", // DAI
	// "resource_rdx1thcmmknq2mlhxzy20pd0kh4w2runhqhhax9tf99n50l9ylg8wf4sne", // BNB
	// "resource_rdx1t4lqx3pzazlfp0e449ued6mmmfysevc8r2tzrcj70kpnlwt9kdpgf8", // PEPE
	// "resource_rdx1t58k9jlygcw27sx7peza34jtk65qhe8y7qxmyp9l09pz5sjgadkcq3", // LINK
];

export const MAX_DEFAULT_TOKEN_COUNT = 50;

export const TOKEN_TABS: Tab[] = [
	{ name: "Top", tags: [], fav: false, wrapped: false },
	// { name: "Owned", tags: [], fav: false, wrapped: false },
	{ name: "Wrapped", tags: [], fav: false, wrapped: true },
	{ name: "DeFi", tags: ["defi", "dex", "lending"], fav: false, wrapped: false },
	{ name: "Memes", tags: ["meme", "memecoin", "culture", "rlyfun"], fav: false, wrapped: false },
	// { name: "rly.fun", tags: ["rlyfun"], fav: false, wrapped: false },
	{ name: "DAO", tags: ["dao", "governance"], fav: false, wrapped: false },
];

type Tab = {
	name: string;
	tags: string[];
	fav: boolean;
	wrapped: boolean;
};

export function filterTokensByTab(tokens: Token[], activeTab: Tab, balances?: Balance[]) {
	if (activeTab == TOKEN_TABS[0]) {
		const intersection = tokens.slice(0, MAX_DEFAULT_TOKEN_COUNT);

		return intersection;
	} else if (activeTab == TOKEN_TABS[1]) {
		const intersection = tokens.filter((t) => parseFloat(balances?.find((bal) => bal.address == t.address)?.amount || 0) > 0);

		// intersection.sort((a: Token, b: Token): number => {
		// 	if (!balances?.length) {
		// 		return 0;
		// 	}

		// 	const balanceA = balances.find((bal) => bal.address == a.address)?.amount || 0;
		// 	const balanceB = balances.find((bal) => bal.address == b.address)?.amount || 0;

		// 	const priceA = balanceA * a.tokenPriceUSD;
		// 	const priceB = balanceB * b.tokenPriceUSD;

		// 	if (priceA < priceB) {
		// 		return 1;
		// 	} else if (priceA > priceB) {
		// 		return -1;
		// 	} else if (balanceA < balanceB) {
		// 		return 1;
		// 	} else if (balanceA > balanceB) {
		// 		return -1;
		// 	} else if (a.tvl < b.tvl) {
		// 		return 1;
		// 	} else if (a.tvl > b.tvl) {
		// 		return -1;
		// 	}

		// 	return 0;
		// });

		return intersection;
	} else if (activeTab == TOKEN_TABS[2]) {
		const intersection = tokens.filter((t) => WRAPPED_TOKENS.includes(t.address));

		return intersection;
	} else {
		const intersection = tokens.filter((t) => t.tags.filter((tg) => activeTab.tags.includes(tg)).length > 0);

		return intersection;
	}
}
